import * as campaignChassisReducer from './campaignChassis';
import * as campaignPartsReducer from './campaignParts';
import * as campaignTasksReducer from './campaignTasks';
import * as campaignReportReducer from './report';
import * as campaignQueryReducer from './query';
import * as listCampaignReducer from './list';
import * as campaignReducer from './campaign';

const Reducers = {
  ...campaignChassisReducer,
  ...campaignReportReducer,
  ...campaignPartsReducer,
  ...campaignTasksReducer,
  ...campaignQueryReducer,
  ...listCampaignReducer,
  ...campaignReducer,
};

export default Reducers;
